import { useEffect, useState } from "react";

type IconProps = {
  className?: string;
  fill?: string;
};

const JobPostedIcon = ({ className, fill = "#2e2e2e" }: IconProps) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="0"
      stroke={fill}
      className={_class}
    >
      <g clip-path="url(#clip0_177531_13944)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22.5 12.75V18.75C22.5 19.5784 21.8284 20.25 21 20.25H3C2.17157 20.25 1.5 19.5784 1.5 18.75V12.75C1.5 11.9216 2.17157 11.25 3 11.25H7.5C7.91421 11.25 8.25 11.5858 8.25 12C8.25 12.4142 7.91421 12.75 7.5 12.75H3V18.75H21V12.75H16.5C16.0858 12.75 15.75 12.4142 15.75 12C15.75 11.5858 16.0858 11.25 16.5 11.25H21C21.8284 11.25 22.5 11.9216 22.5 12.75ZM8.03063 7.28062L11.25 4.06031V12C11.25 12.4142 11.5858 12.75 12 12.75C12.4142 12.75 12.75 12.4142 12.75 12V4.06031L15.9694 7.28062C16.2624 7.57368 16.7376 7.57368 17.0306 7.28062C17.3237 6.98757 17.3237 6.51243 17.0306 6.21938L12.5306 1.71938C12.3899 1.57854 12.1991 1.49941 12 1.49941C11.8009 1.49941 11.6101 1.57854 11.4694 1.71938L6.96938 6.21938C6.67632 6.51243 6.67632 6.98757 6.96938 7.28062C7.26243 7.57368 7.73757 7.57368 8.03063 7.28062ZM18.75 15.75C18.75 15.1287 18.2463 14.625 17.625 14.625C17.0037 14.625 16.5 15.1287 16.5 15.75C16.5 16.3713 17.0037 16.875 17.625 16.875C18.2463 16.875 18.75 16.3713 18.75 15.75Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_177531_13944">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default JobPostedIcon;
